import React from 'react';
import styles from './header.module.scss';
import TopRow from './header/top-row';
import NavRow from './header/nav-row';

function Header() {
  return (
    <header className={styles.header}>
      <div className="container-fluid">
        <TopRow basketCount={1} />
        <NavRow />
      </div>
    </header>
  );
}

export default Header;
